import React, { useEffect, useState } from 'react'
import InfoButton from '../../common/InfoButton'
import BarChartFrequency from './BarChartFrequency'
import { useTranslation } from 'react-i18next'
import { LoadingContainer } from '../student/CheckInWidget'
import { useMemo } from 'react'
import { calculateDateRange } from '../../../utils/dateUtils'
import { getOrganizationCheckingFrequencyAnalyticsInfo } from '../../../server/server'

function EmotionsCheckInFrequency({ daysFilter, selectedUsersScope }) {
    const { t } = useTranslation()
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState({ average: 0, frequency: {} })
    const showLoading = useMemo(() => loading || !data, [loading, data])

    useEffect(() => {
        setLoading(true)
        loadData()
    }, [daysFilter, selectedUsersScope])

    const loadData = async () => {
        const { startDate, endDate } = calculateDateRange(daysFilter)
        const resp = await getOrganizationCheckingFrequencyAnalyticsInfo(selectedUsersScope, startDate, endDate)
        if (resp.status === 200) {
            setData(resp.data)
        } else {
            setData(null)
        }
        setLoading(false)
    }

    return (
        <div className="bg-white rounded-[24px] py-5 px-[18px] mt-4" data-tour="emotional_trends_frequency">
            <div className=" flex flex-row items-center justify-between">
                <div className="flex flex-row items-center gap-2">
                    <p className="text-[18px] leading-[25px] font-medium text-darkenPurple ">{t('Student Check-In Activity')}</p>
                    <div className="flex items-center justify-center rounded-full bg-[#413F5E14] h-6 px-[10px]">
                        <p className="text-[13px] leading-[18px] font-normal text-strongGray ">{t(daysFilter.label)}</p>
                    </div>
                </div>
                <button>
                    <InfoButton
                        color="#5E639B"
                        text={'Weekly check-in frequency analysis showing student engagement patterns \n *Values under 1.0 represent less than one check-in per week on average'}
                    />
                </button>
            </div>
            <div className="relative">
                <DataContainer data={data} blur={showLoading} />
                {showLoading && <LoadingContainer showEmptyData={false} />}
            </div>
        </div>
    )
}

export default EmotionsCheckInFrequency

const DataContainer = ({ data, blur }) => {
    const { t } = useTranslation()
    return (
        <div className={`"mt-4 pb-5 ${blur ? 'blur' : ''}`}>
            <div className="flex-1 flex flex-row items-center gap-4 rounded-[12px] bg-[#F8F7FC] px-3 py-[9px] border border-[#DFDDF3] mt-4">
                <div className="w-[44px] h-[44px] rounded-full bg-white flex items-center justify-center">
                    <InfoButton color="#5E639B" text={'Average weekly check-in frequency per student during the selected time period'} />
                </div>
                <div className="flex flex-col gap-[2px]">
                    <p className="text-[14px] leading-[20px] font-semibold text-darkenPurple ">{t('6 check-ins per student', { number: data.average })}</p>
                    <p className="text-[14px] leading-[20px] font-medium text-darkenPurple ">
                        {t('The average number of check-ins per student for the selected timeframe on weekly basis.')}
                    </p>
                </div>
            </div>
            <BarChartFrequency data={data} />
            <p className="text-[12px] leading-[20px] font-normal text-[#464554] text-center">{t('Number of check-ins on weekly basis in selected timeframe')}</p>
        </div>
    )
}
